module.exports = __webpack_public_path__ + "static/masthead_bg_mobile_france-c7f3334efcc65e6b9d1e6771beaff1ea.jpg";